import { QueryClient } from '@tanstack/react-query';
import { logger } from './logger';

/**
 * Shared QueryClient instance for the web app.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Clear all cached data - both React Query and localStorage.
 * MUST be called on logout to prevent data leakage between users.
 */
export function clearAllCaches(): void {
  // Clear React Query in-memory cache
  queryClient.clear();

  // Clear all Pantry-specific storage keys
  const keysToRemove = [
    'pantry_selected_household_id', // Household selection
    'pantry-theme', // User theme preference (optional - keeps UX consistent)
    'TMG_BATCH_DRAFT', // Batch entry drafts
  ];

  keysToRemove.forEach((key) => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (error) {
      // Ignore storage errors (e.g., in private browsing mode)
      logger.error('Failed to clear storage key', error, { key });
    }
  });

  // Also clear any unknown Pantry-prefixed keys from sessionStorage
  try {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith('pantry') || key.startsWith('TMG_')) {
        sessionStorage.removeItem(key);
      }
    });
  } catch {
    // Ignore errors in private browsing or restricted contexts
  }
}
